export type Volume = {
  label: string
  title: string
  description: string
}

export type Bonus = {
  title: string
  value: string
  description: string
  image: string
}

export const volumes: Volume[] = [
  {
    label: 'VOLUME 1',
    title: 'Fundamentals, Anatomy and Tools',
    description:
      'The scientific and technical base: history, tissue anatomy, the function of every tool, golden rules and a universal 60-minute base protocol.',
  },
  {
    label: 'VOLUME 2',
    title: 'Body Sculpting and Aesthetics',
    description:
      'Protocols for abdomen, flanks, legs, saddlebags and glutes with order, timing, pressure and lymphatic closing. Includes measuring and progress photography.',
  },
  {
    label: 'VOLUME 3',
    title: 'Therapeutic and Specialized Protocols',
    description:
      'Complete 45-minute facial wood therapy protocol for lifting, jawline definition and drainage. Arms and sagging skin. Myofascial release for chronic cervical, dorsal and lower back tension. Post-operative protocols with fibrosis grading. Adaptations for men, pregnancy and older adults.',
  },
  {
    label: 'VOLUME 4',
    title: 'Lymphatic Drainage and Postpartum',
    description:
      'Drainage with wood, fluid retention and a postpartum protocol with safety criteria, diastasis, a 12-session plan and consent forms.',
  },
  {
    label: 'VOLUME 5',
    title: 'Session and Program Design',
    description:
      'Timelines for 30, 45, 60 and 90 minutes, 8 and 12-session programs, service menu, suggested pricing and profitability.',
  },
  {
    label: 'VOLUME 6',
    title: 'Marketing, Business and Management',
    description:
      'A 7-day launch, social media, monthly content, admin, client forms and an action plan for your first 90 days.',
  },
]

export const bonuses: Bonus[] = [
  {
    title: 'Express Map of Protocols by Goal',
    value: '$19',
    description:
      'Find in seconds which protocol to use based on your client goal. Includes a quick table, a 3-question selector and a mobile version.',
    image:
      'https://cdn.magicpatterns.com/uploads/qD53YE7fC4tuSQgpfdsPH5/wood-Bono-1.webp',
  },
  {
    title: 'Pro Safety and Session Preparation Checklist',
    value: '$18',
    description:
      'Prepare every session with a safety traffic light, a pressure scale and a professional welcome script.',
    image:
      'https://cdn.magicpatterns.com/uploads/kPdZhG3Gf8BmQQQRKuqHXs/wood-Bono-2.webp',
  },
  {
    title: '21-Day Agenda to Launch Your Wood Therapy Service',
    value: '$17',
    description:
      'Organize, publish and get your service ready to sell with simple 10 to 30-minute daily tasks.',
    image:
      'https://cdn.magicpatterns.com/uploads/iBeLALY4q61fcr9orHvQ6q/wood-Bono-3.webp',
  },
  {
    title: 'Professional Client Form Pack for Wellness Clients',
    value: '$12',
    description:
      'Intake form, measurement log, subjective progress, consent form and post-session recommendations.',
    image:
      'https://cdn.magicpatterns.com/uploads/wEXbdMec1dpgyKgfeYT6S6/wood-Bono-4.webp',
  },
  {
    title: 'WhatsApp and Instagram Scripts to Sell Wood Therapy',
    value: '$7',
    description:
      '25 scripts, objection responses, captions and story copy ready to copy and paste.',
    image:
      'https://cdn.magicpatterns.com/uploads/6a7FCS2ibLyaxVJEs9ug6i/wood-Bono-5.webp',
  },
]
